/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RepublishCashDisputeEventsRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {RepublishCashDisputeEventsResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const republishCashDisputeEvents = (request: RepublishCashDisputeEventsRequest, options?: CashRequestOptions) => post<RepublishCashDisputeEventsRequest, RepublishCashDisputeEventsResponse>("/2.0/cash/republish-cash-dispute-events", request, {...options, rejectOnError: true })